import getSingle from "./get-single.js";
import getAll from "./get-all.js";

export default {
	getSingle,
	getAll,
};
